export default __webpack_public_path__ + "static/media/home_card2.0e7e6231.svg";